<template>
    <div class="create-contact">
        <div class="header">
            <div class="title">
                <span class="main">Добавление продукта. </span>
                <span class="sub">Заполнение контактов</span>
            </div>
        </div>

        <div class="middle">
            <InformNotice v-if="showInform" class="inform">
                <template #text>
                    <UserInfo :value="currentUser" class="user-info" hide-icon />
                    <span>, ваш контакт будет указан как основной. Не забудьте проверить
                        свою контактную информацию в профиле.<br><br>
                    Вы можете добавить дополнительные контакты</span>
                </template>
            </InformNotice>

            <Contact v-for="(it, id) in contacts" :key="id"
                     v-model="contacts[id]"
                     :required="requiredContacts"
                     :disabled-remove="lastContact"
                     :last-contact="lastContact"
                     :can-select-main="canSelectMain"
                     :index="id + 1"
                     class="contact"
                     @selectMain="onDisableMainOthers(id)"
                     @onRemoveContact="onRemoveContact(id)"
            />
            <button class="iconed no-border primary add-contact" @click="onAddContact">
                <IconPlusSmall class="icon" />
                <span>Добавить контакт</span>
            </button>
        </div>

        <div class="footer two-sided">
            <div class="left">
                <button class="only-icon back" @click="onBack">
                    <IconArrowLeft class="icon" />
                </button>
            </div>
            <div class="right">
                <input class="ghost"
                       type="button"
                       value="Отмена"
                       @click="$emit('close')"
                />
                <input :disabled="v.$invalid || loading"
                       :value="last ? 'Добавить заявку' : 'Далее'"
                       class="primary create"
                       type="button"
                       @click="onNext" />
            </div>
        </div>
    </div>
</template>

<script>
import Contact from '@/common/page_comp/Contacts/edit/Contact.vue';
import InformNotice from '@/common/page_comp/InformNotice/InformNotice.vue';
import UserInfo from '@/common/page_comp/UserInfo/UserInfo.vue';
import { currentUser } from '@/common/session.js';
import { useVuelidate } from '@vuelidate/core';
import { minLength, requiredIf } from '@vuelidate/validators';
import { emptyModel, removeDuplicateContacts } from '@/common/page_comp/Contacts/utli.js';

export default {
    props: {
        value: {
            type: Object,
            required: true,
        },
        requiredContacts: {
            type: Boolean,
            default: true,
        },
        canSelectMain: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        last: {
            type: Boolean,
            default: false,
        },
        showInform: {
            type: Boolean,
            default: false,
        },
        addContactInitially: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        UserInfo,
        InformNotice,
        Contact,
    },
    setup() {
        return {
            v: useVuelidate(),
        };
    },
    validations() {
        return {
            contacts: {
                required: requiredIf(this.requiredContacts),
                minLength: minLength(this.requiredContacts ? 1 : 0),
                hasMainContact: () => this.canSelectMain ? this.hasMainContact : true,
            },
        };
    },
    data() {
        return {
            contacts: [],
        };
    },
    computed: {
        hasMainContact() {
            return this.contacts.some((it) => it.main);
        },
        lastContact() {
            if (!this.addContactInitially)
                return this.contacts.length === 0;

            return this.contacts.length <= 1;
        },
        currentUser() {
            return currentUser();
        },
    },
    methods: {
        onRemoveContact(pos) {
            if (!this.lastContact) {
                this.contacts.splice(pos, 1);
            } else {
                // Когда остался 1 контакт, чистим его состояние, а не удаляем
                this.$set(this.contacts, 0, emptyModel());
            }

            if (!this.hasMainContact && this.canSelectMain)
                this.$set(this.contacts[0], 'main', true);
        },
        onAddContact() {
            const contact = emptyModel();

            if (this.lastContact && !this.hasMainContact && this.canSelectMain)
                contact.main = true;

            this.contacts.push(contact);
        },
        onNext() {
            if (!this.requiredContacts && this.contacts[0]?.type === null)
                this.contacts = [];

            this.removeDuplicates();
            this.checkMain();

            if (this.v.$invalid)
                return;

            this.$emit('next', {
                contacts: this.contacts,
            });
        },
        onBack() {
            this.$emit('back', {
                contacts: this.contacts,
            });
        },
        removeDuplicates() {
            this.contacts = removeDuplicateContacts(this.contacts);
        },
        checkMain() {
            if (!this.hasMainContact && this.canSelectMain)
                this.$set(this.contacts[0], 'main', true);
        },
        onDisableMainOthers(pos) {
            for (let i = 0; i < this.contacts.length; i++) {
                if (i === pos)
                    continue;

                this.$set(this.contacts[i], 'main', false);
            }
        },
    },
    created() {
        this.contacts = [].concat(this.value.contacts ?? []);

        if (this.contacts.length === 0 && this.addContactInitially) {
            this.onAddContact();
        }
    },
};
</script>

<style lang="scss" scoped>
.create-contact {
    .inform {
        margin-bottom: 20px;

        .user-info {
            font-weight: 700;
        }
    }

    .contact {
        margin-bottom: 20px;
    }

    .contact + .contact {
        padding-top: 20px;
        border-top: 1px solid rgba(16, 24, 40, 0.1);
    }

    .add-contact {
        margin-bottom: 20px;
    }

    .create {
        padding-right: 20px;
        padding-left: 20px;
    }
}
</style>
